//
// Conditionally wrap a Component in some more JSX
//
// Usage:
//   <ConditionalWrap
//     condition={shouldLink}
//     wrap={children => <TouchableOpacity onPress={this.onPress}>{children}</TouchableOpacity>}
//   >
//    <OtherComponent />
//  </ConditionalWrap>

function ConditionalWrap({ condition, wrap, children }) {
  return condition ? wrap(children) : children;
}

export default ConditionalWrap;
